import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { ShaftLengthFraction } from '../../api/models';

export type TABLE_TYPE = Table<ShaftLengthFraction>;

export const TABLE = 'shaftLengthFraction';
const SCHEMA = 'shaftLengthFractionId, sortId';

class ShaftLengthFractionDatabase implements DataRepository<ShaftLengthFraction> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<ShaftLengthFraction | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: ShaftLengthFraction, key: Key): Promise<ShaftLengthFraction> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: ShaftLengthFraction[]): Promise<ShaftLengthFraction[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<ShaftLengthFraction[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const ShaftLengthFractionDB = new ShaftLengthFractionDatabase(db);
